/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class EquipmentTransformer extends Transformer {

  static fetch(equipment) {
    return {
      id: equipment.id,
      organizationId: equipment.organization_id,
      name: equipment.name,
      isActive: equipment.is_active,
    };
  }

  static send(equipment) {
    return {
      id: equipment.id,
      name: equipment.name,
      is_active: equipment.isActive,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/equipment.js